import { useMemo, useSyncExternalStore } from 'react'
import { SCOPE_PREVIEW } from '../constants/local_storage'
import { parseScopes } from '../constants/scopes'
import {
  SCOPE_PREVIEW_CHANGE_EVENT,
  scopePreviewStorage
} from '../utils/scopePreviewStorage'

function subscribe(onChange: () => void): () => void {
  window.addEventListener(SCOPE_PREVIEW_CHANGE_EVENT, onChange)
  function handleStorage(e: StorageEvent) {
    if (e.key === null || e.key === SCOPE_PREVIEW) {
      onChange()
    }
  }
  window.addEventListener('storage', handleStorage)
  return () => {
    window.removeEventListener(SCOPE_PREVIEW_CHANGE_EVENT, onChange)
    window.removeEventListener('storage', handleStorage)
  }
}

/**
 * The scope set the UI should render as, or null when not previewing.
 *
 * The snapshot is the raw string so it stays reference-stable; parsing it in
 * getSnapshot would hand useSyncExternalStore a new array every call.
 */
const useScopePreview = (): string[] | null => {
  const raw = useSyncExternalStore(
    subscribe,
    scopePreviewStorage.get,
    scopePreviewStorage.get
  )

  // An empty array is a real preview ("no scopes at all"), so only a missing
  // key means the preview is off.
  return useMemo(() => (raw === null ? null : parseScopes(raw)), [raw])
}

export default useScopePreview
